// extracted by mini-css-extract-plugin
export default {"h1Box":"HotResource_h1Box__j4F26","contentBox":"HotResource_contentBox__qWk0r"};